import { Colors, Services } from '@sigma-frontend-libs/commons'

import { buttonModes, components, icons, states } from '@/utils'

import button from '@/components/button'
import buttonRefresh from '@/components/button/refresh'
import info from '@/components/info'
import pagination from '@/components/pagination'
import preloader from '@/components/preloader'
import paymentsList from '@/components/services/payments/list'
import recurrentPaymentsFilter from '@/components/services/recurrentPayments/filter'
import recurrentPaymentsForm from '@/components/services/recurrentPayments/form'
import recurrentPaymentsItem from '@/components/services/recurrentPayments/item'

function renderCreateDialogBody(h, options) {
  if (this.paymentsMethods.length) {
    return h(
      recurrentPaymentsForm,
      {
        props: {
          value: this.restData[Services.recurrentPayments].create.data,
          errors: this.restData[Services.recurrentPayments].create.errors,
          isNew: true,
          OwnerId: options.OwnerId
        },
        on: {
          input: event => {
            this.restData[Services.recurrentPayments].create.data = event
          },
          submit: () => {
            this.createRecurrentPayment()
          },
          validation: event => {
            this.restData[Services.recurrentPayments].create.isValid = event
          }
        }
      }
    )
  }

  return h(
    'div',
    {
      class: `${Services.recurrentPayments}-info`
    },
    [
      h(
        info,
        {
          props: {
            value: this.getTranslate(`${Services.payments}.infos.method`)
          }
        }
      )
    ]
  )
}
function renderCreateDialogFooter(h) {
  if (this.paymentsMethods.length) {
    const loading = this.restData[Services.recurrentPayments].create.state === states.loading

    return h(
      'div',
      {
        class: 'dialog__footer',
        slot: 'footer'
      },
      [
        h(
          button,
          {
            props: {
              label: this.getTranslate('misc.buttons.cancel'),
              mode: buttonModes.flat
            },
            on: {
              click: () => {
                this.showCreateDialog = false
              }
            }
          }
        ),
        h(
          button,
          {
            props: {
              label: this.getTranslate('misc.buttons.create'),
              color: Colors.primary,
              loading,
              disabled: loading || !this.restData[Services.recurrentPayments].create.isValid
            },
            on: {
              click: this.createRecurrentPayment
            }
          }
        )
      ]
    )
  }

  return h(
    'div',
    {
      class: 'dialog__footer'
    },
    [
      h(
        button,
        {
          props: {
            label: this.getTranslate('misc.buttons.close'),
            mode: buttonModes.flat
          },
          on: {
            click: () => {
              this.showCreateDialog = false
            }
          }
        }
      )
    ]
  )
}
function renderCreateDialog(h, options) {
  if (this.canCreateRecurrentPayments) {
    return h(
      components.dialog,
      {
        props: {
          title: this.getTranslate(`${Services.recurrentPayments}.titles.create`),
          value: this.showCreateDialog,
          maxWidth: 400
        },
        on: {
          input: event => {
            this.showCreateDialog = event
            this.setShowCreateRecurrentPaymentDialog(event)
          }
        }
      },
      [
        renderCreateDialogBody.call(this, h, options),
        renderCreateDialogFooter.call(this, h)
      ]
    )
  }
}
function renderCreateButton(h, options) {
  if (!options.isPage) {
    if (this.canCreateRecurrentPayments) {
      return h(
        button,
        {
          props: {
            icon: icons.add,
            mode: buttonModes.flat,
            color: Colors.secondary
          },
          on: {
            click: () => {
              this.showCreateDialog = true
            }
          },
          scopedSlots: {
            dialog: () => {
              return renderCreateDialog.call(this, h, options)
            }
          }
        }
      )
    }
  }
}

function renderRefreshButton(h) {
  return h(
    buttonRefresh,
    {
      props: {
        state: this.restData[Services.recurrentPayments].find.state,
        shortClickMethod: () => {
          return this.rest[Services.recurrentPayments].find()
        },
        longClickMethod: () => {
          return this.rest[Services.recurrentPayments].find({}, { noCache: true })
        }
      }
    }
  )
}
function renderPagination(h) {
  let paginationChunk = 3
  if (this.viewport.breakpoint.xs) {
    paginationChunk = 1
  }

  return h(
    'div',
    {
      class: 'service-template-pagination'
    },
    [
      h(
        pagination,
        {
          props: {
            value: this.restData[Services.recurrentPayments].find.pagination,
            service: Services.recurrentPayments,
            selectRows: !this.viewport.breakpoint.xs,
            chunk: paginationChunk
          },
          on: {
            input: event => {
              this.restData[Services.recurrentPayments].find.pagination = event
            }
          }
        }
      ),

      renderRefreshButton.call(this, h)
    ]
  )
}
function renderFilter(h, options) {
  return h(
    recurrentPaymentsFilter,
    {
      props: {
        value: this.restData[Services.recurrentPayments].find.filter,
        isPage: !!options.isPage,
        OwnerId: options.OwnerId
      },
      on: {
        input: event => {
          this.restData[Services.recurrentPayments].find.filter = event
        }
      },
      scopedSlots: {
        buttons: () => {
          return [ renderCreateButton.call(this, h, options) ]
        }
      }
    }
  )
}
function renderHeader(h, options) {
  return h(
    'div',
    {
      class: `${Services.recurrentPayments}-list__header`
    },
    [
      renderFilter.call(this, h, options),
      renderPagination.call(this, h, true)
    ]
  )
}

function renderDivider(h) {
  if (this.restData[Services.recurrentPayments].find.pagination.total > 0) {
    return h(components.divider)
  }
}

function renderPreloader(h) {
  return h(
    'div',
    {
      class: 'preloader__holder preloader__holder--absolute pa-5'
    },
    [ h(preloader) ]
  )
}
function renderAbsolutePreloader(h) {
  if (this.restData[Services.recurrentPayments].find.state === states.loading) {
    return h(
      'div',
      {
        class: 'preloader__holder preloader__holder--absolute'
      },
      [ h(preloader) ]
    )
  }
}
function renderItem(h, options, item) {
  return h(
    recurrentPaymentsItem,
    {
      props: {
        value: item,
        isPage: !!options.isPage
      },
      key: item.id,
      on: {
        payments: id => {
          this.RecurrentPaymentId = id
          this.showPaymentsDialog = true
        },
        unlockRecurrentPayment: id => {
          this.RecurrentPaymentId = id
          this.showUnlockConfirmDialog = true
        }
      }
    }
  )
}
function renderItems(h, options) {
  return h(
    'div',
    {
      class: `${Services.recurrentPayments}-list__items`
    },
    [
      this.restData[Services.recurrentPayments].find.data.map(item => {
        return renderItem.call(this, h, options, item)
      }),

      renderAbsolutePreloader.call(this, h)
    ]
  )
}
function renderBody(h, options) {
  if (this.restData[Services.recurrentPayments].find.pagination.total > 0) {
    return renderItems.call(this, h, options)
  } else {
    switch (this.restData[Services.recurrentPayments].find.state) {
      case states.loading: return renderPreloader.call(this, h)
      case states.ready:
      default: return h(components.empty)
    }
  }
}

function renderPaymentsDialog(h) {
  if (this.canGetRecurrentPayments) {
    return h(
      components.dialog,
      {
        props: {
          title: this.getTranslate(`${Services.recurrentPayments}.titles.payments`),
          value: this.showPaymentsDialog,
          maxWidth: 800
        },
        on: {
          input: event => {
            this.showPaymentsDialog = event
          }
        }
      },
      [
        h(paymentsList({ RecurrentPaymentId: this.RecurrentPaymentId })),

        h(
          'div',
          {
            class: 'dialog__footer',
            slot: 'footer'
          },
          [
            h(
              button,
              {
                props: {
                  label: this.getTranslate('misc.buttons.close'),
                  mode: buttonModes.flat
                },
                on: {
                  click: () => {
                    this.showPaymentsDialog = false
                  }
                }
              }
            )
          ]
        )
      ]
    )
  }
}
function renderUnlockConfirmDialog(h) {
  if (this.canGetRecurrentPaymentsAsAdmin) {
    return h(
      components.dialog,
      {
        props: {
          title: this.getTranslate(`${Services.recurrentPayments}.titles.unlock`),
          value: this.showUnlockConfirmDialog,
          maxWidth: 400
        },
        on: {
          input: event => {
            this.showUnlockConfirmDialog = event
          }
        }
      },
      [
        h(
          'div',
          {
            class: 'pa-2'
          },
          [
            h(
              info,
              {
                props: {
                  value: this.getTranslate(`${Services.recurrentPayments}.contents.unlock`)
                }
              }
            )
          ]
        ),
        h(
          'div',
          {
            class: 'dialog__footer',
            slot: 'footer'
          },
          [
            h(
              button,
              {
                props: {
                  label: this.getTranslate('misc.buttons.cancel'),
                  mode: buttonModes.flat,
                  disabled: this.unlockLoading
                },
                on: {
                  click: () => {
                    this.showUnlockConfirmDialog = false
                  }
                }
              }
            ),
            h(
              button,
              {
                props: {
                  label: this.getTranslate('misc.buttons.unlock'),
                  icon: icons.done,
                  color: Colors.success,
                  mode: buttonModes.filled,
                  loading: this.unlockLoading,
                  disabled: this.unlockLoading
                },
                on: {
                  click: () => {
                    this.unlockRecurrentPayment()
                  }
                }
              }
            )
          ]
        )
      ]
    )
  }
}

export default function(h, options) {
  if (this.canGetRecurrentPayments) {
    return h(
      'div',
      {
        class: `${Services.recurrentPayments}-list`
      },
      [
        renderHeader.call(this, h, options),
        renderDivider.call(this, h),
        renderBody.call(this, h, options),
        renderPaymentsDialog.call(this, h),
        renderUnlockConfirmDialog.call(this, h)
      ]
    )
  }
}
